import { render, staticRenderFns } from "./generalTestFile.vue?vue&type=template&id=9bd5c884&"
import script from "./generalTestFile.vue?vue&type=script&lang=js&"
export * from "./generalTestFile.vue?vue&type=script&lang=js&"
import style0 from "./generalTestFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd5c884')) {
      api.createRecord('9bd5c884', component.options)
    } else {
      api.reload('9bd5c884', component.options)
    }
    module.hot.accept("./generalTestFile.vue?vue&type=template&id=9bd5c884&", function () {
      api.rerender('9bd5c884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/general/generalTestFile.vue"
export default component.exports